export default 'prod';


// WEBPACK FOOTER //
// ./env.js